import React from "react";
import { connect } from "react-redux";

import { activeFunderContactSelector } from "reducers";

import { Card } from "react-bootstrap";
import FunderContactDetailForm from "./FunderContactDetailForm";
import { RecordsTable } from "../../components/table";
import { FUNDER_CONTACT_AFFILIATION_MODAL } from "../../components/modals";
import FunderContactAffiliationTable from "./FunderContactAffiliationTable";
import { selectFunderContactAffiliation, showModal } from "../../actions";

const FunderContactOverview = ({ funderContactInfo, ...props }) => {
  React.useEffect(() => {
    if (funderContactInfo && funderContactInfo.name) {
      document.title = `LifeRoc | ${funderContactInfo.name} | Counter Party Contact`;
    }
  }, [funderContactInfo]);

  return (
    <div className={`section-card shadowed case-section`} style={{ marginTop: "5.5rem" }}>
      <Card className={"case-info"}>
        <Card.Body>
          <FunderContactDetailForm funderContactInfo={funderContactInfo} />
          <RecordsTable
            title="Counter Parties Affiliations"
            createButtonLabel="Add Counter Party Affiliation"
            onCreateClick={e => {
              e.preventDefault();
              props.selectFunderContactAffiliation(null);
              props.showModal(FUNDER_CONTACT_AFFILIATION_MODAL);
            }}
            Table={FunderContactAffiliationTable}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    funderContactInfo: activeFunderContactSelector(state),
  };
};

export default connect(mapStateToProps, { selectFunderContactAffiliation, showModal })(FunderContactOverview);
